Promise = require 'bluebird'
PollTimeoutError = require './poll-timeout-error'

module.exports = (pollster, isFinal) ->
  unsubscribe = null
  result = new Promise (resolve, reject) ->
    unsubscribe = pollster.state.subscribe (state) ->
      if 'error' of state
        reject state.error
      else if 'timeout' of state
        reject PollTimeoutError()
      else if 'value' of state && isFinal(state.value)
        resolve state.value
      return
    return

  pollster.start()

  pollster.finished.then ->
    unsubscribe()

  result.finally ->
    pollster.stop()
